"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createVueComponent = _interopRequireDefault(require("../createVueComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Podcast = (0, _createVueComponent.default)('PodcastIcon', [['circle', {
  cx: '12',
  cy: '11',
  r: '1'
}], ['path', {
  d: 'M17.03 18.46a9 9 0 10-10.02.03'
}], ['path', {
  d: 'M16.06 13.91a5 5 0 10-7.97.2'
}], ['path', {
  d: 'M11.11 17a.9.9 0 111.78 0l-.52 4.67a.37.37 0 01-.74 0l-.52-4.68z'
}]]);
var _default = Podcast;
exports.default = _default;